import { render, staticRenderFns } from "./BlockEditProperty.vue?vue&type=template&id=e05f6234&scoped=true&"
import script from "./BlockEditProperty.vue?vue&type=script&lang=js&"
export * from "./BlockEditProperty.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditProperty.vue?vue&type=style&index=0&id=e05f6234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05f6234",
  null
  
)

export default component.exports